/******/ (() => { // webpackBootstrap
  var __webpack_exports__ = {};
  window.PXUTheme.jsVideo = {
    init: function ($section) {
  
      // Add settings from schema to current object
      window.PXUTheme.jsVideo = $.extend(this, window.PXUTheme.getSectionData($section));
  
      // Selectors
      const $videoElement = $section.find('[data-video-element]');
      const $playIcon = $section.find('.plyr--paused.plyr--video .plyr__control--overlaid');
      const $playButton = $section.find('[data-play-button]');
      const $videoTextContainer = $section.find('[data-video-text-container]');
      const $imageElement = $section.find('[data-image-element]');
  
      // Defer loading the iframe/player until user interaction
      const self = this;
  
      // Default state: show image/text, hide video container

      $imageElement.show();
      $videoTextContainer.show();
      $videoElement.hide();
  
      function injectIframeIfNeeded() {
        if (!$videoElement.length) return;
  
        // Only inject once
        if ($videoElement.data('loaded')) return;
  
        // If iframe video configured, build iframe now
        if (self.iframe_video && ($videoElement.data('videoId') || self.iframe_video.id)) {
          const videoId = $videoElement.data('videoId') || self.iframe_video.id;
          const videoType = ($videoElement.data('videoType') || self.iframe_video.type || '').toLowerCase();
  
          let src = '';
          if (videoType === 'youtube') {
            src = 'https://www.youtube.com/embed/' + videoId + '?iv_load_policy=3&modestbranding=1&playsinline=1&showinfo=0&rel=0&enablejsapi=1&origin=' + encodeURIComponent(window.location.origin);
          } else if (videoType === 'vimeo') {
            src = 'https://player.vimeo.com/video/' + videoId + '?loop=false&byline=false&portrait=false&title=false&speed=true&transparent=0&gesture=media';
          }
  
          if (src) {
            const iframe = document.createElement('iframe');
            iframe.setAttribute('src', src);
            iframe.setAttribute('allowfullscreen', '');
            iframe.setAttribute('allowtransparency', '');
            iframe.setAttribute('frameborder', '0');
            iframe.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture');
            // Ensure iframe fills responsive wrapper
            iframe.style.position = 'absolute';
            iframe.style.top = '0';
            iframe.style.left = '0';
            iframe.style.width = '100%';
            iframe.style.height = '100%';
            // Empty and append iframe
            $videoElement.empty()[0].appendChild(iframe);
          }
        }
  
        $videoElement.attr('aria-hidden', 'false');
        $videoElement.data('loaded', true);
      }
  
      function startPlayback(e) {
        if (e) { e.preventDefault(); }
        injectIframeIfNeeded();
        // Show video, hide image
        // Force-hide image even if theme CSS uses !important
        $imageElement.each(function() { this.style.setProperty('display', 'none', 'important'); });
        $videoElement.show();
        // Ensure video layers above any overlays
        $videoElement.css({ position: 'relative', zIndex: 2 });
        // Keep text visible but non-blocking
        $videoTextContainer.css('pointer-events', 'none');
        // Keep text container visible during playback
  
        // Show loading spinner overlay while player initializes
        const $container = $imageElement.closest('.image-wrapper-container');
        if ($container.length && !$container.find('.video-loading-spinner').length) {
          const spinner = document.createElement('div');
          spinner.className = 'video-loading-spinner';
          spinner.setAttribute('aria-live', 'polite');
          spinner.setAttribute('role', 'status');
          spinner.style.position = 'absolute';
          spinner.style.top = '50%';
          spinner.style.left = '50%';
          spinner.style.transform = 'translate(-50%, -50%)';
          spinner.style.width = '40px';
          spinner.style.height = '40px';
          spinner.style.border = '3px solid rgba(255,255,255,0.6)';
          spinner.style.borderTopColor = '#000';
          spinner.style.borderRadius = '50%';
          spinner.style.animation = 'pxu-spin 0.8s linear infinite';
          spinner.style.zIndex = '3';
  
          // Ensure the wrapper can host an absolute element
          const host = $container[0];
          if (getComputedStyle(host).position === 'static') {
            host.style.position = 'relative';
          }
          host.appendChild(spinner);
          // Inject keyframes once
          if (!document.getElementById('pxu-spin-style')) {
            const style = document.createElement('style');
            style.id = 'pxu-spin-style';
            style.textContent = '@keyframes pxu-spin { from { transform: translate(-50%, -50%) rotate(0deg); } to { transform: translate(-50%, -50%) rotate(360deg); } }';
            document.head.appendChild(style);
          }
        }
        // Initialize player lazily and play when ready
        if (!self._player) {
          self._player = self.loadVideo($videoElement, $playIcon, $playButton, $videoTextContainer, $imageElement);
          if (self._player) {
            const tryPlay = () => {
              const playPromise = self._player.play();
              if (playPromise && typeof playPromise.then === 'function') {
                playPromise.catch(() => {});
              }
            };
            if (self._player.ready) {
              tryPlay();
            } else {
              self._player.on('ready', tryPlay);
            }
            // Remove spinner when ready/playing
            const removeSpinner = () => {
              const $container = $imageElement.closest('.image-wrapper-container');
              $container.find('.video-loading-spinner').remove();
            };
            self._player.on('ready', removeSpinner);
            self._player.on('playing', removeSpinner);
          }
        } else {
          const playPromise = self._player.play();
          if (playPromise && typeof playPromise.then === 'function') {
            playPromise.catch(() => {});
          }
          const $container2 = $imageElement.closest('.image-wrapper-container');
          $container2.find('.video-loading-spinner').remove();
        }
      }
  
      // Bind click handlers to start playback
      // Clean existing handlers to prevent multiple clicks required
      $playButton.off('click');
      $videoTextContainer.off('click');
      $imageElement.off('click');
  
      if (this.button && $playButton.length) {
        $playButton.on('click', startPlayback);
      } else {
        $videoTextContainer.on('click', startPlayback);
      }
  
      // Mobile: clicking the image wrapper should also start playback when text is below image
      if (!isScreenSizeLarge() && $videoElement.parents('.mobile-text--below-media')) {
        $imageElement.on('click', startPlayback);
      }
  
    },
    loadVideo: function($videoElement, $playIcon, $playButton, $videoTextContainer, $imageElement) {
      const player = new Plyr(`.video-${this.id}`, {
        controls: videoControls,
        loop: {
          active: this.autoloop
        },
        fullscreen: {
          enabled: true,
          fallback: true,
          iosNative: true
        },
        storage: {
          enabled: false
        }
      });
  
      player.muted = this.mute;
      player.ratio = this.aspect_ratio;
  
      // Always start from placeholder; we only show/play on explicit click
      $videoElement.hide();
      $imageElement.show();
      $videoTextContainer.show();
  
      // Click bindings happen in init to avoid multiple bindings and premature loads
  
      // On player ready, hide play icon if play button visible
      player.on('ready', function(index, player) {
        if ($playButton && !isScreenSizeLarge() && $videoElement.parents('.mobile-text--below-media')) {
          $playIcon.show();
        } else if ($playButton) {
          $playIcon.hide();
        } else {
          $playIcon.show();
        }
      })
  
      // On play, hide image and show video element
      player.on('play', function(index, player) {
        $videoElement.show();
        // Ensure image is hidden even if playback starts via controls
        $imageElement.each(function() { this.style.setProperty('display', 'none', 'important'); });
        // Keep text container visible during playback and non-blocking
        $videoElement.css({ position: 'relative', zIndex: 2, height: 572});
        $videoTextContainer.css('pointer-events', 'none');
      })
  
      // On player pause, show play icon if play button hidden
      player.on('pause', function(index, player) {
        if (!$playButton) {
          $playIcon.show();
        }
      })
  
      return player;
    },
    unload: function($section) {
      const $playButton = $section.find('[data-play-button]');
      const $videoTextContainer = $section.find('[data-video-text-container]');
  
      $playButton.off();
      $videoTextContainer.off();
    }
  }
  
  /******/ })()
  ;